import script from "./BannerCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./BannerCriarEditar.vue?vue&type=style&index=0&id=4ae71661&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ae71661"]])

export default __exports__